import React from "react";
import { Center, Column } from "@/shared/ui/Blocks";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import {
  BaseDimensionDetails,
  BaseDimensionDetailsProps,
} from "./BaseDimensionDetails";
import MarkdownText from "../MarkdownText";
import { useDimensionTextSelectors } from "@/shared/hooks/content/useDimensionTextSelectors";
import { Person } from "@/features/people/graphql/generated";
import { useModal } from "@/shared/utils/hooks/useModal";
import { ModalFileName } from "@/shared/modals";
import { IconButton } from "@/shared/ui/IconButton";

interface DimensionDetailsProps extends BaseDimensionDetailsProps {
  subDimensions?: DimensionWithScores[];
  showSubDimensions?: boolean;
  defaultOpen?: boolean;
}

function DimensionDetails(props: DimensionDetailsProps) {
  const {
    dimension,
    scores,
    subDimensions,
    extremes,
    context = "user",
  } = props;

  const [openDimensionModal] = useModal(ModalFileName.DIMENSION_DETAILS);

  const { insightsDescription } = useDimensionTextSelectors(
    dimension,
    subDimensions || [],
    context
  );

  const handleDimensionClick = () => {
    openDimensionModal({
      dimension,
      allDimensions: subDimensions || [dimension],
      context,
    });
  };

  const people = dimension.peopleScores.map(
    (score) => score?.person
  ) as Person[];

  return (
    <BaseDimensionDetails
      dimension={dimension}
      scores={scores}
      extremes={extremes}
      context={context}
      DescriptionComponent={
        <Column className="mt-8 print:mt-0">
          <MarkdownText
            className="print:text-sm"
            text={insightsDescription || ""}
            data={{
              dimensions: subDimensions || [dimension],
              people,
              forceGrouping: false,
            }}
          />
        </Column>
      }
    >
      <Center>
        <IconButton
          variant="outline"
          icon="Expand"
          label="Show details"
          className="print:hidden personality-map-dimension-single-see-more"
          onClick={handleDimensionClick}
        />
      </Center>
    </BaseDimensionDetails>
  );
}

export { DimensionDetails };
